export const DEFAULT_VENUE_CONDUCTOR_PROMPTS = [
  'Place a hold for [artist] at [venue] on [date]',
  'Is [date] free at [venue]?',
  'Link my [artist] offer to the [venue] confirm',
  'Broadcast engagement last month',
  'How are ticket sales this month?',
  'Show me upcoming events',
  'Total expenses across all [artist] offers',
  'What are my top fan markets?'
];
